require('./brokerErrorView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const WizardError = require('components/commons/wizardError/wizardError')

// @ constants
const { DEFAULT_TRANSLATION_TEXT } = require('constants/translations');

// @helpers
const {
    MYPROFILE_BROKER_URL
} = require('constants/index');

const BrokerErrorView = (
        state
) => {
    const title = formatText('broker-errorTitle');
    const breadcrumb = [
        {
            text: formatText('corporatesOperations-start'),
            url: '/myprofile/global'
        },
        {
            text: formatText('corporatesOperations-investments'),
            url: '/myprofile/broker'
        },
        {
            text: formatText('broker-error'),
            url: ''
        }
    ];
    const errorKey = state.immBrokerError.get('brokerErrorReceived');
    const showTealium = state.immBrokerError.get('showTealium');
    let errorMessage = errorKey ? formatText(errorKey) : formatText('broker-errorPrimaryMessage');

    if (errorMessage === DEFAULT_TRANSLATION_TEXT) {
        errorMessage = formatText('broker-errorPrimaryMessage');
    }

    const mainButton = {
        label: formatText('broker-errorGoToMyWallet'),
        url: MYPROFILE_BROKER_URL
    }
    return (
        <div className="broker-errors-view">
            <OKCover size="medium" section="pg">
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumb}
                />
            </OKCover>
            <WizardError
                errorMessage={title}
                customClassName="broker-errors-view__body"
                mainButton={mainButton}
                showTealium={showTealium}
            >
                <div>
                    <div className="broker-errors-view__primary-message">
                        {errorMessage}
                    </div>
                    <div>
                        <FormattedText
                            value="broker-errorSecondaryMessage"
                            injectedStrings={[formatText('emails-investments')]}
                        />
                    </div>
                </div>
            </WizardError>
        </div>
    );
};

BrokerErrorView.propTypes = {
    immBrokerError: PropTypes.object
};

module.exports.constructor = BrokerErrorView;
module.exports.BrokerErrorView = connect(
    state => ({
        immBrokerError: state.brokerError
    }), {

    })(BrokerErrorView);
